/** @format */

/**
 * React ionic breakpoints
 */
export const screenSize = {
  Small: '576px',
  Medium: '768px',
  Large: '992px',
  ExtraLarge: '1200px',
};

/**
 * Example Usage:
 * import globalStyles from 'path/to-here/global-styles/theme';
 *
 *  [GlobalStyles.Device.Tablet] {
 *    height: ${tabletHeight};
 *  }
 * `;
 */
export const Device = {
  Mobile: `@media (max-width: ${screenSize.Small}`,
  Tablet: `@media (max-width: ${screenSize.Medium})`,
  Laptop: `@media (min-width: ${screenSize.Large})`,
};

export default Device;
